//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../library/umum";

export default {
  data() {
    return {
        listData: [],
        listKegiatan: [],
        listFoto : [],
        listVideo : [],
        fotoObj : null,
        fotoIndex : 0,
        mFoto : false,
        UMUM: UMUM,
    };
  },
  methods: {
    getKegiatan() {
      fetch(this.$store.state.url.URL_CNT_KEGIATAN_TERBARU + "list5", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
            des_kel: this.$store.state.ID_DES_KEL,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.listKegiatan = res_data;
          // console.log(res_data);
        });
    },
    getFoto(){
      fetch(this.$store.state.url.URL_CNT_GALLERY_FOTO + "list6", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listFoto = res_data
              // console.log(res_data)
             
      });
    },

    getVideo(){
      fetch(this.$store.state.url.URL_CNT_GALLERY_VIDEO + "list4", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
              des_kel: this.$store.state.ID_DES_KEL,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listVideo = res_data
              // console.log(res_data)
             
      });
    },


    selectFoto(index, foto){
      this.fotoIndex = index
    //   console.log(index)
        this.fotoObj = this.listFoto[this.fotoIndex];
        this.mFoto = true;

    },
    showFoto(){
    },
    pushKegiatan: function(id) {
      this.$store.state.kegiatan.id = id;
      this.$store.commit("getOne");
      this.$router.push("/detilKegiatan?id=" + id);
    },
  },
  mounted() {
    this.getKegiatan();
    this.getFoto();
    this.getVideo();
  }
};
